var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pui-loader",
    { attrs: { promise: _vm.emailSettingsPromise } },
    [
      _c("edit-email-template-modal", {
        ref: _vm.REF_CONSTANTS.EDIT_EMAIL_TEMPLATE_MODAL,
        on: { "update:email-template": _vm.fetchEmailSettings },
      }),
      _c(
        "div",
        { staticClass: "email-settings-tab" },
        [
          _vm._l(_vm.STATUS_SETTINGS_CONFIG, function (status, statusKey) {
            return _c(
              "pui-collapsible",
              {
                key: statusKey,
                staticClass: "email-settings-tab__collapsible",
                attrs: { expandable: false, headline: _vm.$t(status.label) },
              },
              _vm._l(
                _vm.PROCESSES,
                function (process, processKey, processIndex) {
                  return _c(
                    "div",
                    {
                      key: processIndex,
                      staticClass: "email-settings-tab__collapsible__content",
                    },
                    [
                      processIndex !== 0
                        ? _c("hr", {
                            staticClass:
                              "email-settings-tab__collapsible__content__process-collapsible__separator",
                          })
                        : _vm._e(),
                      _c(
                        "pui-collapsible",
                        {
                          staticClass:
                            "email-settings-tab__collapsible__content__process-collapsible",
                          attrs: {
                            open:
                              Number(statusKey) ===
                                _vm.openedEmailSection.color &&
                              Number(processKey) ===
                                _vm.openedEmailSection.process,
                            headline: _vm.$t(process.label),
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "email-settings-tab__collapsible__content__process-content",
                            },
                            _vm._l(
                              _vm.getEmailSettings(statusKey, processKey),
                              function (item, emailIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: emailIndex,
                                    staticClass:
                                      "email-settings-tab__collapsible__content__process-content__setting-row",
                                  },
                                  [
                                    _c(
                                      "pui-headline",
                                      { attrs: { type: "h6" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                _vm.SUB_PROCESSES[
                                                  item.subProcess
                                                ].label
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c("pui-form-input-field", {
                                      staticClass:
                                        "email-settings-tab__collapsible__content__process-content__setting-row__email-field",
                                      attrs: {
                                        value: _vm.checkEmptyForEmail(
                                          item.email
                                        ),
                                        "is-disabled": true,
                                      },
                                    }),
                                    _c(
                                      "pui-button",
                                      {
                                        attrs: { small: "", icon: "edit" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openEditEmailTemplateModal(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "emailSettingsTab.editTemplate"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }
              ),
              0
            )
          }),
          _c("pui-collapsible", {
            staticClass: "email-settings-tab__collapsible",
            attrs: {
              expandable: false,
              configurable: true,
              headline: _vm.$t("emailSettingsTab.commentsTemplate"),
            },
            scopedSlots: _vm._u([
              {
                key: "collapsibleConfigurationContent",
                fn: function () {
                  return [
                    _c(
                      "pui-button",
                      {
                        attrs: { small: "", icon: "edit" },
                        on: {
                          click: function ($event) {
                            return _vm.openEditEmailTemplateModal()
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("emailSettingsTab.editTemplate")) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }